export default __webpack_public_path__ + "static/media/670.ddb8354e.gif";